<template>
  <el-dropdown @command="handlerCommand" class="export-excel">
    <el-button class="btn btn-size-s export-excel__btn">
      <i class="icon-db excel"/>
    </el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="current">{{L10n('current-page')}}</el-dropdown-item>
      <el-dropdown-item command="all">{{L10n('all-page')}}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  methods: {
    handlerCommand (command) {
      command = command[0].toUpperCase() + command.substring(1)
      this.$emit(`on${command}`)
    }
  }
}
</script>
<style lang="stylus">
.export-excel{
  &__btn.btn{
    padding .8rem
    margin-left .2rem
    min-width unset
  }
}
</style>
